module.exports = __webpack_public_path__ + "fonts/Simply Rounded.ecea8592.ttf";